// sentry

import * as Sentry from '@sentry/browser'
import * as Integrations from '@sentry/integrations'

export default {
  install(Vue) {
    if (process.env.NODE_ENV === 'production') {
      Sentry.init({
        dsn: 'https://e8746b166b884f60abf479359eac1307@sentry.myjiedian.com/19',
        release: process.env.VUE_APP_SENTRY_RELEASE_VERSION,
        integrations: [new Integrations.Vue({ Vue, attachProps: true })],
        environment: location.host === 'finance-dev.nodetech-inc.com' ? 'staging' : 'prod'
      })
    }
  }
}
